<template>
    <div class="sebrae-topbar__session" role="timer" aria-live="polite" aria-label="Tempo de sessão">
        <countdown :time="tempo" format="HH:mm:ss" @finish="endCallBack()">
            <template #="{ resolved }">
                <span class="sebrae-topbar__session-label">Tempo de Sessão</span>
                <span class="sebrae-topbar__session-value">
                    {{ resolved.HH }} : {{ resolved.mm }} : {{ resolved.ss }}
                </span>
            </template>
        </countdown>
    </div>
</template>

<script>
import Countdown from 'vue3-countdown';

export default {
    name: 'TempoSessao',

    data() {
        return {
            tempo: 60 * 1000,
        };
    },

    methods: {
        endCallBack() {
            this.$store.dispatch('logout');
        },
    },

    created() {
        let x = this.$moment(this.$store.getters.getExpirationDate);
        let y = this.$moment();
        this.tempo = this.$moment.duration(x.diff(y)).asMilliseconds();
    },

    components: {
        Countdown,
    },
};
</script>
